import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { FRP_COLOR_STOPS } from 'features/mapping/components/layers/NgfsDetectionsLayer';

// Stepped gradient of the layer's FRP colors so the legend matches the map
// exactly: each color fills an equal-width band with hard edges (per the Figma
// design), a visual intensity guide rather than a to-scale axis.
export const buildFrpGradient = (): string => {
  const bandWidth = 100 / FRP_COLOR_STOPS.length;
  const stops = FRP_COLOR_STOPS.flatMap(([, color], i) => {
    const start = Math.round(i * bandWidth);
    const end = Math.round((i + 1) * bandWidth);
    return [`${color} ${start}%`, `${color} ${end}%`];
  });
  return `linear-gradient(90deg, ${stops.join(', ')})`;
};

const useStyles = makeStyles()((theme) => ({
  guide: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  bar: {
    background: buildFrpGradient(),
    height: 10,
    borderRadius: 10,
    flex: 1,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

export const FrpScaleGuide = (): JSX.Element => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.guide} component="span">
      <Typography variant="caption" color="textSecondary" component="span">
        {t('map.legends.satellite.legends.ngfs.scaleLow')}
      </Typography>
      <Box className={classes.bar} component="span" />
      <Typography variant="caption" color="textSecondary" component="span">
        {t('map.legends.satellite.legends.ngfs.scaleHigh')}
      </Typography>
    </Box>
  );
};
